import React, { useEffect } from "react";

// Declare the custom element in JSX.IntrinsicElements
declare module "react" {
  namespace JSX {
    interface IntrinsicElements {
      "free-text-enrichment-ui-for-centric": React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLElement>,
        HTMLElement
      > & {
        "access-token": string;
        "product-dev-id": string;
        "season-number": string;
      };
    }
  }
}

const FreeTextEnrichmentPLMUI = (props: {
  productDevId: any;
  seasonNumber: any;
  accessToken: string;
}) => {
  useEffect(() => {
    const id = "free-text-enrichment-ui-app";
    if (document.getElementById(id) === null) {
      const host = process.env.REACT_APP_FREE_TEXT_ENRICHMENT_CDN_URL;
      const getManifest = async () =>
        await fetch(host + "/asset-manifest.json" + "?ver=" + Math.random())
          .then((res) => res.json())
          .then((manifest) => {
            const script = document.createElement("script");
            script.id = id;
            script.src = `${host}${manifest.files["main.js"]}`;
            return script;
          });
      getManifest().then((x) => {
        document.head.appendChild(x);
      });
    }
  }, []);

  return (
    <>
      {props.accessToken && (
        <free-text-enrichment-ui-for-centric
          product-dev-id={props.productDevId}
          season-number={props.seasonNumber}
          access-token={props.accessToken}
        ></free-text-enrichment-ui-for-centric>
      )}
    </>
  );
};
export default FreeTextEnrichmentPLMUI;
